// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1OMqr","alert":"SettungsInbox_alert__2gaZD"};